document.addEventListener('DOMContentLoaded', () => {
  updateSecondaryOccupations()
  updateSubjects()
  updateSubSubjects()
  addSubjectButton()
  syncSecondaryOccupationExclusions()
  checkPrefsAll()
  updatePrefectures()
  checkEmpsAll()
  updateEmployment()
});

function updateSecondaryOccupations() {
  const primarySelects = document.getElementsByClassName('primary-occupations')
  Array.from(primarySelects).forEach((primary) => {
    primary.addEventListener("change", () => {
      const controller = primary.dataset.controller
      const rank = primary.dataset.rank
      const primary_id = primary.value

      $.ajax({
        type: 'GET',
        url: `/${controller}/occupations?rank=${rank}&occupation_id=${primary_id}`
      })
    })
  })
}

function updateSubjects() {
  const secondarySelects = document.getElementsByClassName('secondary-occupations')
  Array.from(secondarySelects).forEach((secondary) => {
    secondary.addEventListener("change", () => {
      const controller = secondary.dataset.controller
      const rank = secondary.dataset.rank
      const secondary_id = secondary.value

      syncSecondaryOccupationExclusions()

      $.ajax({
        type: 'GET',
        url: `/${controller}/subjects?rank=${rank}&occupation_id=${secondary_id}`
      })
    })
  })
}

function updateSubSubjects() {
  const subjectSelects = document.getElementsByClassName('subjects')
  Array.from(subjectSelects).forEach((subject) => {
    subject.addEventListener("change", () => {
      const controller = subject.dataset.controller
      const rank = subject.dataset.rank
      const subject_id = subject.value
      const subject_rank = subject.dataset.subjectRank

      const params = new URLSearchParams()
      params.append('rank', rank)
      params.append('subject_id', subject_id)
      if (subject_rank !== undefined) {
        params.append('subject_rank', subject_rank)
      }

      $.ajax({
        type: 'GET',
        url: `/${controller}/sub_subjects?${params.toString()}`
      })
    })
  })
}

function addSubjectButton() {
  const btns = document.getElementsByClassName('subject-add-button')
  Array.from(btns).forEach((btn) => {
    btn.addEventListener("click", () => {
      const index = parseInt(btn.dataset.index, 10);
      const rank = btn.dataset.rank
      $('#desire_' + rank + '_subjects_' + (index + 1)).show()
      $('#subject_add_button_' + (index - 1)).hide()
    })
  })
}

window.syncSecondaryOccupationExclusions = function() {
  const selects = document.querySelectorAll('.secondary-occupations');
  if (selects.length === 0) return;

  // 協会希望職種ページでのみ実行（履歴書・登録ページでは重複選択可）
  var isOrgDesires = Array.from(selects).some(function(s) {
    return s.dataset.controller && s.dataset.controller.indexOf('/organizations/') !== -1;
  });
  if (!isOrgDesires) return;

  const selections = [];
  selects.forEach(function(select) {
    if (select.value) selections.push({ el: select, val: select.value });
  });

  selects.forEach(function(select) {
    Array.from(select.options).forEach(function(option) {
      if (!option.value) return;
      option.disabled = selections.some(function(s) {
        return s.val === option.value && s.el !== select;
      });
    });
  });
}

function checkPrefsAll() {
  const checkPrefsAll = document.getElementById('checkPrefsAll'); // "checkPrefsAll" のIDを持つ要素を取得
  if (!checkPrefsAll) return; // 要素が存在しない場合は早期リターン
  checkPrefsAll.addEventListener('change', () => {
    const prefsCheckboxes = document.getElementsByClassName('prefs'); // "prefs" クラスを持つ全てのチェックボックスを取得
    const isChecked = checkPrefsAll.checked; // チェックボックスの状態を確認

    Array.from(prefsCheckboxes).forEach((checkbox) => {
      checkbox.checked = isChecked; // 各チェックボックスの状態を変更
    });
  });
}

function updatePrefectures() {
  const button = document.getElementById('attachPrefIds')
  if (button) {
    button.addEventListener("click", () => {
      // Get checked prefecture ids and names
      let ids = []
      let names = []
      Array.from(document.getElementsByClassName('prefs')).forEach((pref) => {
        if (pref.checked === true) {
          ids.push(pref.value)
          names.push(pref.name)
        }
      })
      const idsParent = document.getElementById('pref-ids')
      const controller = idsParent.dataset.controller
      // Remove previous ids
      Array.from(idsParent.children).forEach((child) => child.remove())
      // Attach ids
      ids.map((id) => {
        let input = document.createElement('input')
        input.setAttribute('value', id)
        input.setAttribute('multiple', 'multiple')
        input.setAttribute('autocomplete', 'off')
        input.setAttribute('type', 'hidden')
        input.setAttribute('name', `${controller}[prefecture_ids][]`)
        input.setAttribute('id', `${controller}_prefecture_ids`)

        idsParent.appendChild(input)
      })
      // Attach names
      document.getElementById("pref-names").innerText = names.length > 0 ? names.join(',') : '選択なし'
    })
  }
}

function checkEmpsAll() {
  const checkPrefsAll = document.getElementById('checkEmpsAll'); // "checkPrefsAll" のIDを持つ要素を取得
  if (!checkPrefsAll) return; // 要素が存在しない場合は早期リターン
  checkPrefsAll.addEventListener('change', () => {
    const prefsCheckboxes = document.getElementsByClassName('emps'); // "prefs" クラスを持つ全てのチェックボックスを取得
    const isChecked = checkPrefsAll.checked; // チェックボックスの状態を確認

    Array.from(prefsCheckboxes).forEach((checkbox) => {
      checkbox.checked = isChecked; // 各チェックボックスの状態を変更
    });
  });
}


function updateEmployment() {
  const button = document.getElementById('attachEmpIds')
  if (button) {
    button.addEventListener("click", () => {
      // Get checked employment ids and names
      let ids = []
      let names = []
      Array.from(document.getElementsByClassName('emps')).forEach((emp) => {
        if (emp.checked === true) {
          ids.push(emp.value)
          names.push(emp.name)
        }
      })
      const idsParent = document.getElementById('emp-ids')
      const controller = idsParent.dataset.controller
      // Remove previous ids
      Array.from(idsParent.children).forEach((child) => child.remove())
      // Attach ids
      ids.map((id) => {
        let input = document.createElement('input')
        input.setAttribute('value', id)
        input.setAttribute('multiple', 'multiple')
        input.setAttribute('autocomplete', 'off')
        input.setAttribute('type', 'hidden')
        input.setAttribute('name', `${controller}[employment_ids][]`)
        input.setAttribute('id', `${controller}_employment_ids`)

        idsParent.appendChild(input)
      })
      // Attach names
      document.getElementById("emp-names").innerText = names.length > 0 ? names.join(',') : '選択なし'
    })
  }
}
